import { Link } from "react-router-dom";
import { ArrowUpRight, Database, Globe, ShieldCheck, Users, ArrowRight, Leaf } from "@phosphor-icons/react";
import { TEST_IDS } from "@/constants/testIds";
import AvailableDatasets from "@/components/AvailableDatasets";

export default function Dashboard() {
    return <div className="sdx-home">
            <section data-testid={TEST_IDS.dashboardHero} className="sdx-hero">
                <div className="sdx-hero-leaves" aria-hidden="true"><i/><i/><i/></div>
                <div className="sdx-hero-inner">
                    <span className="sdx-eyebrow"><span /> Open by design. Verified by community.</span>
                    <img className="sdx-hero-logo" src="/images/sustaindex-logo-hd.png" alt="SustainDex yellow leaf logo" width="104" height="104" />
                    <h1>SustainDex</h1>
                    <div className="sdx-hero-subtitle">Sustainability Data Exchange</div>
                    <p>A shared, verified registry for sustainability data across materials,<br className="hidden md:block" /> processes, and environmental parameters.</p>
                    <div className="sdx-hero-actions">
                        <Link to="/explore" data-testid={TEST_IDS.dashboardExploreCta} className="btn-secondary">Explore the Registry <ArrowRight size={18} /></Link>
                        <Link to="/submit" data-testid={TEST_IDS.dashboardSubmitCta} className="sdx-hero-secondary">Contribute a Source <ArrowUpRight size={18} /></Link>
                    </div>
                    <div className="sdx-platform-visual" aria-label="From source evidence to community-reviewed sustainability data">
                        <div className="sdx-visual-header"><span><Leaf size={18} weight="fill" /> THE SUSTAINDEX REGISTRY</span><span>Materials · Processes · Parameters</span></div>
                        <div className="sdx-data-flow">
                            <div><span className="sdx-flow-icon"><Database size={30} weight="duotone" /></span><h3>Traceable sources</h3><p>Source, citation & methodology</p></div>
                            <ArrowRight className="sdx-flow-arrow" size={25} />
                            <div><span className="sdx-flow-icon sdx-flow-community"><Users size={30} weight="duotone" /></span><h3>Community validation</h3><p>Review, discuss & compare</p></div>
                            <ArrowRight className="sdx-flow-arrow" size={25} />
                            <div><span className="sdx-flow-icon"><Globe size={30} weight="duotone" /></span><h3>Shared knowledge</h3><p>Open sustainability data</p></div>
                        </div>
                        <div className="sdx-visual-footer"><ShieldCheck size={16} /> Every value has a story. Explore the evidence behind it.<Link to="/explore">Explore data <ArrowUpRight size={14} /></Link></div>
                    </div>
                </div>
            </section>

        <AvailableDatasets />
    </div>;
}
